import React from 'react'
import styles from './SpeakerComponent.module.scss'

interface WebinarCardProps {
    Webinar?: WebinarUI;
  }

const TriSpeaker = ({ Webinar }: WebinarCardProps) => {
  return (
    <div className={styles.WebinarSpeakerWrapper}>
      {Webinar?.Speaker?.[0] && (
        <div className={styles.FirstSpeakerContainer}>
          <div className={styles.WebinarSpeakerImageContainer}>
            <img
              width={500}
              height={100}
              className={styles.WebinarImageSpeaker}
              src={Webinar.Speaker[0]?.SpeakerImage?.data?.attributes?.url}
              alt={Webinar.Speaker[0]?.SpeakerName || "Speaker Image"}
            />
            <div className={styles.WebinarSpeakerName}>
              <p className="text-sm font-semibold ">
                {Webinar?.Speaker[0]?.SpeakerName}
              </p>
              <p className={styles.speakerDesignation}>{Webinar?.Speaker[0]?.Designation}</p>
            </div>
          </div>
        </div>
      )}

      {Webinar?.Speaker && (
        <div className={styles.OtherSpeakersContainer}>
          {Webinar?.Speaker?.slice(1).map((speaker, index) => (
            <div key={index} className={styles.WebinarSpeakerContainer}>
              <div className={styles.WebinarSpeakerImageContainer}>
                <img
                  width={500}
                  height={100}
                  className={styles.WebinarImageSpeaker}
                  src={speaker?.SpeakerImage?.data?.attributes?.url}
                  alt={speaker?.SpeakerName || "Speaker Image"}
                />   <div className={styles.WebinarSpeakerName}>
                <p className="text-sm font-semibold ">
                  {speaker?.SpeakerName}
                </p>
                <p className={styles.speakerDesignation}>{speaker?.Designation}</p>
              </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TriSpeaker
